module.exports = __webpack_public_path__ + "img/close-circle-grey71.2d2b5ba8.svg";